import { useState } from "react";
import { Play } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "./motion";
import { idYoutube, urlEmbedSpotify } from "./embeds";

// Video de YouTube con carga al hacer clic (sin autoplay prometido).
export function VideoSeccion({ datos, seccion, p = "we" }) {
  const [cargado, setCargado] = useState(false);
  const id = idYoutube(datos.video?.urlYoutube || "");
  if (!id) return null;

  return (
    <section className={`${p}-seccion`} aria-label={seccion.titulo}>
      <div className={`${p}-seccion-interior`}>
        <EncabezadoSeccion p={p} etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid={`${p}-titulo-video`} />
        <Reveal>
          <div className={`${p}-video`}>
            {cargado ? (
              <iframe
                src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`}
                title={seccion.titulo || "Video"}
                allow="accelerometer; autoplay; encrypted-media; picture-in-picture"
                allowFullScreen
                loading="lazy"
                data-testid={`${p}-video-iframe`}
              />
            ) : (
              <button
                type="button"
                className={`${p}-video-portada`}
                onClick={() => setCargado(true)}
                aria-label="Reproducir video"
                data-testid={`${p}-video-reproducir`}
              >
                <img src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`} alt="" loading="lazy" />
                <span className={`${p}-video-play`}>
                  <Play strokeWidth={1.5} fill="currentColor" />
                </span>
              </button>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

// Música: Spotify (reproductor compacto) o MP3 (propio), nunca ambos.
export function MusicaSeccion({ datos, seccion, p = "we" }) {
  const musica = datos.musica;
  if (!musica?.url) return null;

  const esSpotify = musica.tipo === "spotify";
  const embedSpotify = esSpotify ? urlEmbedSpotify(musica.url) : null;
  if (esSpotify && !embedSpotify) return null;

  return (
    <section className={`${p}-seccion`} aria-label={seccion.titulo}>
      <div className={`${p}-seccion-interior`}>
        <EncabezadoSeccion p={p} etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid={`${p}-titulo-musica`} />
        <Reveal>
          <div className={`${p}-musica`} data-testid={`${p}-musica`}>
            {embedSpotify ? (
              <iframe
                src={embedSpotify}
                height="152"
                title={seccion.titulo || "Música"}
                allow="encrypted-media"
                loading="lazy"
                data-testid={`${p}-musica-spotify`}
              />
            ) : (
              <audio className={`${p}-audio`} controls preload="none" src={musica.url} data-testid={`${p}-musica-audio`} />
            )}
            {musica.nota && <p className={`${p}-musica-nota`}>{musica.nota}</p>}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
